import { Button } from 'components/Button/Button'
import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'
import type { TValueGroup } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import { toggleValueGroups } from 'stores/selectedValueGroupsStore/toggleValueGroups'
import { fadeInOutStylesMaker } from 'utils/fadeInOutStylesMaker'

export const DeselectAllLayersButton = ({ visible }: { visible: boolean }) => {
  return (
    <span css={{ ...fadeInOutStylesMaker(visible), marginRight: 12 }}>
      <Button
        variant="link"
        size="xs"
        css={{ color: colors.white }}
        styles={{
          root: { height: 'auto', minHeight: 'var(--button-height)' },
          label: { whiteSpace: 'normal', textAlign: 'right' },
        }}
        onClick={(event) => {
          event.stopPropagation()

          const selectedValueGroups = Object.keys(selectedValueGroupsStore.getState().selectedValueGroups)

          toggleValueGroups(selectedValueGroups as TValueGroup[], false)
        }}
      >
        {translate.phrases.banyanApp('Deselect All')}
      </Button>
    </span>
  )
}
